import React from 'react';
import styled from 'styled-components';
import { globalTheme } from '@clds/component-theme';
import Progress from '@clds/progress';
import { Add } from '@clds/icon';
import StyledTreeNode from '../TreeNode/StyledTreeNode';
import StyledChildrenWrapper from '../TreeNode/StyledChildrenWrapper';
import StyledToggleWrapper from '../TreeNode/StyledToggleWrapper';
import treeNodeDefaults from '../TreeNode/defaults';

const StyledShowMore = styled(StyledTreeNode)`
  font-weight: normal;
  color: ${globalTheme.palette.primary};

  svg {
    fill: ${globalTheme.palette.primary};
  }
`;

const ShowMore = ({ depth, progress, size = treeNodeDefaults.size, ...props }) => {
  return (
    <StyledShowMore depth={depth} size={size} {...props}>
      <StyledToggleWrapper size={size}>{progress ? <Progress.Circular size="sm" /> : <Add size="xs" />}</StyledToggleWrapper>
      <StyledChildrenWrapper size={size}>{progress ? 'Loading more...' : 'More...'}</StyledChildrenWrapper>
    </StyledShowMore>
  );
};

export default ShowMore;
